module.exports = __webpack_public_path__ + "img/MD_635x250px-desktop.d3234d9.webp";